module.exports = __webpack_public_path__ + "img/2-removebg-preview.15016ef9.png";